import portalEn from '@/modules/payment/locales/portal/en.json'
import portalRu from '@/modules/payment/locales/portal/ru.json'

export const seoRu = {
  landing: {
    title: 'Gonka Game — AI-инструменты и партнёрская игра',
    description:
      'Знакомьтесь с AI-продуктами Gonka Game, приглашайте друзей и следите за развитием своей команды. Вход и регистрация в личном кабинете.',
  },
  registration: {
    title: 'Регистрация — Gonka Game',
    description:
      'Создайте аккаунт Gonka Game, чтобы познакомиться с продуктами, пригласить друзей и следить за своей командой.',
  },
  'ai-studio': {
    title: 'AITA.center — тексты, фото и видео',
    description:
      'Откройте AITA.center через аккаунт Gonka Game: работа с текстами, изображениями, видео и документами. Инструменты и тарифы.',
  },
  'nyro-art': {
    title: 'Nyro.Art — творческие AI-инструменты · Gonka Game',
    description:
      'Познакомьтесь с Nyro.Art и перейдите к сервису через аккаунт Gonka Game.',
  },
  ami: {
    title: 'AmiChat — чат-боты для бизнеса — Gonka Game',
    description: 'Познакомьтесь с AmiChat: чат-боты для общения с клиентами и автоматизации продаж. Перейдите в сервис через аккаунт Gonka Game.',
  },
  dashboard: {
    title: 'Личный кабинет — Gonka Game',
    description:
      'Команда, кошелёк, уровни игры и карта AI-продуктов Gonka Game. Следите за своим аккаунтом в одном месте.',
  },
  'dashboard-prestart': {
    title: 'Предстарт — Gonka Game',
    description:
      'Подготовьтесь к старту Gonka Game: подключите сообщество, выберите стратегию и познакомьтесь с доступными продуктами.',
  },
  'affiliate-partner': {
    title: 'Партнёрская программа — Gonka Game',
    description:
      'Узнайте условия партнёрской программы Gonka Game и найдите свою ссылку для приглашения друзей.',
  },
  'affiliate-curator': {
    title: 'Мой куратор — Gonka Game',
    description: 'Контакты вашего куратора в Gonka Game и переход к вышестоящим кураторам.',
  },
  'affiliate-teams': {
    title: 'Моя команда — Gonka Game',
    description:
      'Смотрите участников своей команды Gonka Game, приглашения и связи между рефералами.',
  },
  wallet: {
    title: 'Кошелёк — Gonka Game',
    description:
      'Проверьте баланс кошелька Gonka Game, пополните его и перейдите к истории операций.',
  },
  'wallet-history': {
    title: 'История операций — Gonka Game',
    description:
      'Просматривайте пополнения, списания и другие операции кошелька Gonka Game с их датами и статусами.',
  },
  profile: {
    title: 'Настройки профиля — Gonka Game',
    description:
      'Управляйте личными данными, контактами и настройками своего аккаунта Gonka Game.',
  },
  'tma-init': {
    title: 'Вход через Telegram — Gonka Game',
    description:
      'Откройте Gonka Game в Telegram и войдите в свой аккаунт через мини-приложение.',
  },
  'referral-landing': {
    title: 'Приглашение в игру — Gonka Game',
    description:
      'Вы получили приглашение в Gonka Game. Познакомьтесь с проектом и зарегистрируйтесь по ссылке пригласившего участника.',
  },
  'payment-onchainpay': {
    title: 'Оплата криптовалютой — Gonka Game',
    description:
      'Проверьте сумму, сеть и адрес для оплаты криптовалютой в Gonka Game. Следите за статусом платежа и подтверждениями перевода.',
  },
  'payment-portal': portalRu.seo,
  chains: {
    title: 'Уровни игры — Gonka Game',
    description:
      'Перейдите к доступному потоку Gonka Game и посмотрите его состояние.',
  },
  'flows-demo': {
    title: 'Демонстрация потоков — Gonka Game',
    description:
      'Познакомьтесь с работой потоков Gonka Game в демонстрационном режиме.',
  },
  'gnk-lab': {
    title: 'Лаборатория анимации — Gonka Game',
    description:
      'Посмотрите визуальные эксперименты и анимации Gonka Game.',
  },
  'matrix-level': {
    title: 'Потоки — Gonka Game',
    description:
      'Посмотрите выбранный поток Gonka Game, размещения участников и его состояние.',
  },
}

export const seoEn = {
  landing: {
    title: 'Gonka Game — AI tools and a partner game',
    description:
      'Explore Gonka Game AI products, invite friends and follow your team’s progress. Sign in or create your account.',
  },
  registration: {
    title: 'Create an account — Gonka Game',
    description:
      'Join Gonka Game to explore products, invite friends and follow your team.',
  },
  'ai-studio': {
    title: 'AITA.center for text, photos and video — Gonka Game',
    description:
      'Open AITA.center with your Gonka Game account for text, images, video and documents. Discover the available tools and plans.',
  },
  'nyro-art': {
    title: 'Nyro.Art — creative AI tools · Gonka Game',
    description:
      'Explore Nyro.Art and open the service with your Gonka Game account.',
  },
  ami: {
    title: 'AmiChat — chatbots for business — Gonka Game',
    description: 'Explore AmiChat chatbots for customer conversations and sales automation. Open the service with your Gonka Game account.',
  },
  dashboard: {
    title: 'Dashboard — Gonka Game',
    description:
      'Your Gonka Game team, wallet, game levels and AI product map. Follow your account in one place.',
  },
  'dashboard-prestart': {
    title: 'Prestart — Gonka Game',
    description:
      'Get ready for Gonka Game: join the community, choose your strategy and explore the available products.',
  },
  'affiliate-partner': {
    title: 'Partner program — Gonka Game',
    description:
      'Learn about the Gonka Game partner program and find your personal link to invite friends.',
  },
  'affiliate-curator': {
    title: 'My curator — Gonka Game',
    description: 'Find your Gonka Game curator’s contacts and view the curators above them.',
  },
  'affiliate-teams': {
    title: 'My team — Gonka Game',
    description:
      'View your Gonka Game team members, invitations and referral connections.',
  },
  wallet: {
    title: 'Wallet — Gonka Game',
    description:
      'Check your Gonka Game wallet balance, add funds and open your transaction history.',
  },
  'wallet-history': {
    title: 'Transaction history — Gonka Game',
    description:
      'Review Gonka Game wallet deposits, debits and other transactions with their dates and statuses.',
  },
  profile: {
    title: 'Profile settings — Gonka Game',
    description:
      'Manage your personal details, contacts and Gonka Game account settings.',
  },
  'tma-init': {
    title: 'Sign in with Telegram — Gonka Game',
    description:
      'Open Gonka Game in Telegram and sign in to your account through the mini app.',
  },
  'referral-landing': {
    title: 'An invitation to play — Gonka Game',
    description:
      'You have been invited to Gonka Game. Explore the project and sign up using your inviter’s referral link.',
  },
  'payment-onchainpay': {
    title: 'Crypto payment — Gonka Game',
    description:
      'Check the amount, network and address for your Gonka Game crypto payment. Follow the payment status and transfer confirmations.',
  },
  'payment-portal': portalEn.seo,
  chains: {
    title: 'Game levels — Gonka Game',
    description:
      'Open an available Gonka Game flow and check its status.',
  },
  'flows-demo': {
    title: 'Flow demo — Gonka Game',
    description:
      'Explore how Gonka Game flows work in demonstration mode.',
  },
  'gnk-lab': {
    title: 'Animation lab — Gonka Game',
    description:
      'Explore Gonka Game visual experiments and animations.',
  },
  'matrix-level': {
    title: 'Flows — Gonka Game',
    description:
      'View the selected Gonka Game flow, participant placements and its status.',
  },
} satisfies Record<keyof typeof seoRu, { title: string; description: string }>
